import type { FaireProductEntity } from "../../entity_types/product";

export const p_2au4zys6qz: FaireProductEntity = {
  token: "p_2au4zys6qz",
  type: "product",
  name: "Natural Shampoo Bar | All-in-One Shampoo & Conditioning",
  brandToken: "b_4ciczg6knl",
  brandName: "Lanikai  Bath and Body",
  imageUrl:
    "https://cdn.faire.com/fastly/b22a92824e2426d5460165637bd6f55c47e8f954fa01926bf6554f0bd3b1c468.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b14fddfa624f098a3d673ce27b3f8fe751f88713d878e755d6c5aef2773b4abb.jpeg",
    "https://cdn.faire.com/fastly/df403d79fbf2f9837148d8c098d294a8a1371be740f241dc2d5d77bd5891fa39.jpeg",
    "https://cdn.faire.com/fastly/52fcbdfd62bcde5b8fc3871c9836fcb079c70dff1c182c634b7aaa18fdf96859.jpeg",
    "https://cdn.faire.com/fastly/73b2688d9f9cd3cbf49e32a49036cf80c21ece3fc2b502b99c69a9fc9c8538b8.jpeg",
    "https://cdn.faire.com/fastly/e1e1e8379064b6c4f8ad272ac70bfd37f83db0f5b796bcd7b78af149b78c3123.jpeg",
    "https://cdn.faire.com/fastly/c35c4e924aab7d02a3c78b47bdcb820377d5329f23961a29ba5e157d0b002d81.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Natural Shampoo Bar in tropical and botanical fragrances, an all-in-one shampoo and conditioner crafted to gently cleanse and deeply moisturize both hair and scalp. Its rich, creamy lather delivers gentle, quality care without harsh detergents. \n\nFree from sulfates, silicones, and parabens, this bar eliminates stripping while preserving protective oils. Packaged in a TSA-friendly travel tin, it’s perfect for both everyday use and on-the-go convenience.\n\nKey Features\n\nAll-in-one formula: Combines shampoo and conditioner in a single, ultra-convenient bar.\nMild & moisturizing: Excellent for keeping hair and scalp nourished, with a thick, creamy lather.\nClean and safe: No SLS, no silicones, no parabens—pure, gentle cleansing without harsh detergents.\nEco-conscious design: A zero-waste alternative that replaces plastic bottles and chemical preservatives.\nTravel-friendly\n\nIngredients: Shea butter, Organic Coconut Oil, Kukui and Macadamia Nut oils, Sweet Almond Oil, botanical fragrance.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:27.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
